import Vue from "vue";
import VueRouter from "vue-router";
import DashboardLayout from "../components/layout/DashboardLayout.vue";
import store from "../store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    beforeEnter: (to, from, next) => {
      if (store.getters["auth/authenticated"]) {
        return next({
          name: "Dashboard"
        });
      }
      next();
    }
  },
  {
    path: "/adminlogin",
    name: "AdminLogin",
    component: () => import("../views/AdminLogin.vue")
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue")
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/emergency",
    name: "Emergency",
    component: () => import("../views/Emergency.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/events",
    name: "Events",
    component: () => import("../views/Events.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/records",
    name: "Records",
    component: () => import("../views/Records.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("../views/Report.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/Settings.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/navigations",
    name: "Navigations",
    component: () => import("../views/Navigations.vue"),
    meta: { layout: DashboardLayout },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/nav/:id",
    name: "Navigation",
    component: () => import("../views/SingleNavigation.vue"),
    meta: { layout: DashboardLayout },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/streams/:id",
    name: "Streams",
    component: () => import("../views/Streams.vue"),
    meta: { layout: DashboardLayout },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/event/:id",
    name: "Event",
    component: () => import("../views/Event.vue"),
    meta: { layout: DashboardLayout },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  },
  {
    path: "/media/:id",
    name: "SingleMedia",
    component: () => import("../views/Media.vue"),
    meta: { layout: DashboardLayout },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "Login"
        });
      }
      next();
    }
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
